module.exports = __webpack_public_path__ + "static/media/search.a5d54ef2.svg";